export const state = [
  ["ANDAMAN AND NICOBAR ISLANDS", "01"],
  ["ANDHRA PRADESH", "02"],
  ["ARUNACHAL PRADESH", "03"],
  ["ASSAM", "04"],
  ["BIHAR", "05"],
  ["CHANDIGARH", "06"],
  ["DADRA & NAGAR HAVELI ", "07"],
  ["DAMAN & DIU", "08"],
  ["DELHI", "09"],
  ["GOA", "10"],
  ["GUJARAT", "11"],
  ["HARYANA", "12"],
  ["HIMACHAL PRADESH", "13"],
  ["JAMMU & KASHMIR", "14"],
  ["KARNATAKA", "15"],
  ["KERALA", "16"],
  ["LAKHSWADEEP", "17"],
  ["MADHYA PRADESH ", "18"],
  ["MAHARASHTRA", "19"],
  ["MANIPUR", "20"],
  ["MEGHALAYA", "21"],
  ["MIZORAM", "22"],
  ["NAGALAND", "23"],
  ["ORISSA", "24"],
  ["PONDICHERRY", "25"],
  ["PUNJAB", "26"],
  ["RAJASTHAN", "27"],
  ["SIKKIM", "28"],
  ["TAMILNADU", "29"],
  ["TRIPURA ", "30"],
  ["UTTAR PRADESH", "31"],
  ["WEST BENGAL", "32"],
  ["CHHATISHGARH ", "33"],
  ["UTTARANCHAL", "34"],
  ["JHARKHAND", "35"],
  ["TELANGANA", "36"],
  ["LADAKH ", "37"],
  ["JAMMU", "38"],
  ["KASHMIR", "39"],
  ["DEFENSE", "88"],
];
